import {
  getActiveSubscriptions,
  purchaseSubscription,
  cancelSubscription,
} from 'utils/queries/subscription';

export const subscriptionEndpoints = (build) => ({
  getActiveSubscriptions: build.query({
    query: (userId) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getActiveSubscriptions,
        variables: { userId },
      }),
    }),
    transformResponse: (response) => response.data.getActiveSubscriptions,
  }),
  purchaseSubscription: build.mutation({
    query: ({ userId, priceName, paymentMethod }) => ({
      method: 'POST',
      body: JSON.stringify({
        query: purchaseSubscription,
        variables: { userId, priceName, paymentMethod },
      }),
    }),
    transformResponse: (response) => response.data.purchaseSubscription,
  }),
  cancelSubscription: build.mutation({
    query: (userId) => ({
      method: 'POST',
      body: JSON.stringify({
        query: cancelSubscription,
        variables: { userId },
      }),
    }),
    transformResponse: (response) => response.data.cancelSubscription,
  }),
});
